module.exports = __webpack_public_path__ + "79a501240eac05eb5c729333f0db561e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp10.jpeg
// module id = 1135
// module chunks = 0